import React from 'react';
import Input from '../../../forms/Input';
import SelectField from '../../../forms/SelectField';
import { toSelectionFormat } from '../../../../lib/collection.utils';
import { CLEARING_OPTIONS } from '../../../../constants/settings';
import { filter, find } from 'lodash';

const ContractMediaPartnerInputs = ({ onInput, data, dependencies, staticData }) => (
    <React.Fragment>
        <div className="ckp-admin-grid-row">
            <div className="ckp-admin-grid-column">
                <SelectField
                    items={toSelectionFormat(filter(dependencies.partners, dp => !find(staticData, sd => sd.partnerId === dp.id && data.partnerId !== dp.id)))}
                    label="Partner Name *"
                    onChange={onInput}
                    name="partnerId"
                    value={data.partnerId}
                />
            </div>
            <div className="ckp-admin-grid-column">
                <SelectField
                    items={CLEARING_OPTIONS}
                    label="Live Clearance *"
                    onChange={onInput}
                    name="live"
                    value={data.live}
                />
            </div>
            <div className="ckp-admin-grid-column">
                <SelectField
                    items={CLEARING_OPTIONS}
                    label="Non Linear Clearance *"
                    onChange={onInput}
                    name="nonLinear"
                    value={data.nonLinear}
                />
            </div>
        </div>
        <div className="ckp-admin-grid-row">
            <div className="ckp-admin-grid-column">
                <Input maxLength={100} label="Comments" name="comments" onChange={onInput} value={data.comments} />
            </div>
        </div>
    </React.Fragment>
);

export default ContractMediaPartnerInputs;



// WEBPACK FOOTER //
// ./src/components/admin/forms/contracts/ContractMediaPartnerInputs.js